<template>
  <!-- class="el-main-1"  -->
  <div class="el-main-1" style="background-color:ghostwhite;margin-top: 20px;">
    <el-row type="flex">
      <el-col :span="5">
        <div style="background-color:#fff">
          <div style="text-align: left; margin-left: 10px;  color: #0162c3 ; font-weight: bold; height: 60px; display: flex ;align-items: center; ">
            <i class="el-icon-position"> </i>个人中心
          </div>
          <el-menu :default-active="pageRoute.pageState" @select="handleSelect" style="background-color:#fff;text-align: left;" >
            <el-menu-item  index='0'  style="margin: 0px; font-size: 20px; ">个人信息</el-menu-item>
            <el-menu-item  index='1'  style="margin: 0px; font-size: 20px; ">安全考试</el-menu-item>
            <el-menu-item  index='2'  style="margin: 0px; font-size: 20px; ">错题集</el-menu-item>
          </el-menu>
        </div>
      </el-col>
      <el-col  :span="19" style="margin-left:50px">
        <div style="background-color:#fff; " >
          <el-breadcrumb separator="/"  style="height:60px; margin-left: 10px;margin-left: 20px; font-size:20px;  display: flex ;align-items: center;">
            <el-breadcrumb-item ><a class=""  v-on:click ="routeFunc" >首页</a></el-breadcrumb-item>
            <el-breadcrumb-item >个人中心</el-breadcrumb-item>
            <el-breadcrumb-item >{{ pageRoute.pageDir }}</el-breadcrumb-item>
          </el-breadcrumb>
          <el-divider></el-divider>
          <div>
            <div style ="margin-top: 5px;display: flex; margin-left: 20px; " v-if = "pageRoute.pageState == '0'">
              <div>
                <el-image  v-if = "userInfo.imageUrl != null && userInfo.imageUrl != '' "
                  style="width: 100px; height: 100px ; border-radius: 1px;"
                  :src="userInfo.imageUrl"
                  :fit="'fit'">
                </el-image>
                <el-avatar v-else style="display: flex; background-color: rgb(47, 47, 228); height:100px;width:100px; align-items: center; justify-content: space-around; "> {{ userInfo.fullName  }} </el-avatar>
              </div>
              <div style="margin-left: 10px;text-align: left;">
                <div>  
                    姓名: {{userInfo.fullName }}
                </div>
                <div>  
                    工号: {{userInfo.usrName }}
                </div>
                <div>  
                    性别: {{userInfo.genderShow }}
                </div>
                <div>  
                    电话: {{userInfo.mobilePhone }}
                </div>
                <div>  
                    邮箱: {{userInfo.email }}
                </div>
                <div>  
                    团队: {{userInfo.deptName }}
                </div>
                <div style="margin-top: 20px">  
                   <el-button type="primary" @click = "handleEdit"> 修改个人信息</el-button>
                   <el-button type="warning" @click="changePass"> 修改密码</el-button>
                   <!-- <el-button type="danger" @click="restPass"> 重置密码</el-button> -->
                </div>
              </div>
            </div>
            <div class="" style ="margin-top: 5px;" v-if = "pageRoute.pageState == '1'">
              <el-card v-for = " (item,index) in examList" :key="item.id" style=" width: 95%;margin-left: 10px;margin-top: 10px; height: 100px; text-align: left;">
                <div style ="display:flex;align-items: center;">  
                  <el-tag  style ="display:inline-block" v-if = "item.examState == 1"  effect="dark" size="mini" type="info">未开考</el-tag>
                  <el-tag  style ="display:inline-block" v-else-if = "item.examState == 2"  effect="dark" size="mini" type="success">已开考</el-tag>
                  <el-tag  style ="display:inline-block"  v-else effect="dark" size="mini" type="danger">已结束</el-tag>
                  <span style ="display:inline-block;width: 80%; margin-left:10px; overflow: hidden;text-overflow: ellipsis; white-space: nowrap;"> {{index  + 1 }}.主题: {{item.examTheme }}</span> 
                  
                  
                  <!-- 未开始啥都不显示examState = 1 -->

                  <!-- 已经开始 -->
                  <el-tag  size="mini"   type="warning" style="margin-left:5px"
                    v-if = "item.examState == 2 && item.usrState == 1 ">  
                    已开考,可考试
                  </el-tag>
                  
                  <el-tag size="mini" type="info" style="margin-left:5px"
                    v-if = "item.examState == 3
                    && item.usrState == 1 ">  
                    已结束,未考试
                  </el-tag>

                  <el-tag size="mini" type="success" style="margin-left:5px"
                    v-if = "item.examState == 2
                    && item.usrState == 2  && !item.selfExamOver">  
                    已开考,考试中
                  </el-tag>
                  
                  <el-tag size="mini" type="danger" style="margin-left:5px"
                    v-if = "item.examState == 2
                    && item.usrState == 2  && item.selfExamOver">  
                    考试中,已超时
                  </el-tag>
                  <el-tag size="mini" type="success" style="margin-left:5px"
                    v-if = "
                     item.usrState == 3 ">  
                    已完成考试
                  </el-tag>
                  
                  <el-tag  size="mini"   type="success" style="margin-left:5px"
                    v-if = "item.examState > 1 && item.usrState == 3  &&  item.result == 1 ">  
                    合格
                  </el-tag>
                  
                  <el-tag  size="mini"   type="danger" style="margin-left:5px"
                    v-if = "item.examState > 1 && item.usrState == 3  &&  item.result == 0">  
                    不合格
                  </el-tag>
                  <span style="margin-left:5px">|</span>
                  <!-- 已经完成考试或者考试结束未参加考试  -->
                  <!-- <el-button   size="mini" type="primary" style="margin-left:10px"
                    v-if = "item.usrState == 3 || (item.examState == 3 && item.usrState != 2 ) "
                     @click="seePaper(item.examId)">  
                    查看试卷
                  </el-button> -->
               
                  <!-- 中断并且未超时，不计入考试截止时间-->
                  <el-tag style="cursor:pointer;margin-left:5px;"   type = "primary"  size="mini"
                    v-if = "(item.usrState == 2
                    &&!item.selfExamOver)"  @click="handleViewPaper(item.examId,null)">  
                    继续答题
                  </el-tag>
                  <!-- 并且自己考试时间用完 -->
                  <el-tag  style="cursor:pointer;margin-left:5px;"   @click="handleCommitPaper(item.examId)"   type = "warning" size="mini"
                    v-if = "item.usrState == 2 && item.selfExamOver ">  
                    交卷 
                  </el-tag>  
                  <el-tag style="cursor:pointer;margin-left:5px;"  @click="handleViewPaper(item.examId,null)"  
                    size="mini" type = "primary"
                    v-if = "item.examState == 2 && item.usrState == 1 "> 
                    开始答题
                  </el-tag>

                  <el-tag size="mini" type="info" style="margin-left:5px"
                    v-if = "item.examState == 3
                    && item.usrState == 1 ">  
                    无考试记录
                  </el-tag>
                  <el-dropdown v-else  @command="handleCommandExam">
                    <el-tag size="mini" style="margin-left:5px;cursor: pointer;" class="el-dropdown-link">
                      考试记录<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-tag>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if = "item.examCount == 1"  divided  :command=" {examId:item.examId,examCount:1, examMaxCount:item.examCount }" >
                        <i :style="item.result == 1 ? 'color: #67C23A;':''" :class="item.result == 1 ? 'el-icon-success':'el-icon-warning'">当前考试 </i>
                      </el-dropdown-item>
                      <el-dropdown-item v-else  divided v-for=" (ite,index) in item.examCount" :command="{examId:item.examId,examCount:ite, examMaxCount:item.examCount }" :key="index">
                        <i v-if = " ite == 1"  class="el-icon-warning"> 第1次考试 </i>
                        <i v-else-if = "ite < item.examCount && ite > 1  "  class="el-icon-warning">{{ ' 第' + (ite - 1) + '次重考'}} </i>
                        <i v-else :style="item.result == 1 ? 'color: #67C23A;':''" :class="item.result == 1 ? 'el-icon-success':'el-icon-warning'"> 当前考试</i>
                      </el-dropdown-item>
                      <el-dropdown-item divided :disabled = "item.examState == 3" :command="{examId:item.examId,examCount:0, examMaxCount:item.examCount }" v-if = "item.result == 0">
                        <i style="color: #c2433a;" class="el-icon-warning" > 重考</i>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <i v-if = "item.examState > 1 && item.usrState == 3  &&  item.result == 1 " style="margin-left:5px; color: rgb(43, 255, 0);cursor:pointer" class=" el-icon-download "  @click="showZs(item)"></i>
                  <i v-if = "item.examState > 1 && item.usrState == 3  &&  item.result == 1 " class="el-icon-printer " style="margin-left:10px;color: rgb(0, 21, 255); cursor:pointer"  @click="printZs(item)"></i>
                </div>
                <div style="margin-top:10px;font-size:15px;">
                  <span>发布时间:{{ item.publishTime }}</span>   <span>开始时间:{{ item.startTime }}</span>   <span>截止时间:{{ item.endTime }}</span>  
                </div>
              </el-card>
              <el-pagination v-if = "pageRoute.pageState == '1'"
                background
                layout="total,prev, pager, next"
                @current-change="handleCurrentChange"
                :page-size="pager.pageSize"
                :total="pager.totalCount" style="margin-top : 20px; margin-bottom: 20px;">
              </el-pagination> 
          </div>
            <div class=""  style ="margin-top: 5px;width:99%; " v-if = "pageRoute.pageState == '2'">
              <el-card v-if ="qbErrorView.errorId != '' && qbErrorView.errorId != 0" style="height:calc(86vh - 50px);text-align:left ; margin-top:10px;margin-left:20px; overflow:auto;">
                <div slot="header" class="clearfix">
                  <el-tag type="warning">{{ qbErrorView.uniqNo }}</el-tag>
                  <el-tag style ="margin-left: 10px;">{{ qbErrorView.moduleName }}</el-tag>
                  <el-tag type="success">{{ qbErrorView.answerCheckType }}</el-tag>
                  <el-button  type="danger" style="el-icon--right" @click="removeErrorQb()" size = "small" icon="">移出错题集 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
                </div>
                <div style ="margin-top: 10px;" >
                  <el-tag type="warning">问题</el-tag>
                  <span style ="margin-left: 10px;">{{qbErrorView.question }}</span>
                </div>
                <div style ="margin-top: 10px;" v-if = "qbErrorView.imageUrlList.length > 0 "> 
                  <el-tag type="warning" style="padding-top: 0px">图片</el-tag>
                  <el-badge  v-for="(item,index) in qbErrorView.imageUrlList" :key = "index"  :value="index + 1" class="item">
                    <el-image   
                      style="width: 100px; height: 100px;margin-left: 10px; "
                      :src="item.url"
                      :fit="fit">
                    </el-image>
                  </el-badge>
                </div>
                <div style ="margin-top: 10px;">
                  <el-checkbox-group v-model="qbErrorView.checkedOptList" >
                    <el-tag type="warning">选项</el-tag>
                    <el-checkbox style ="margin-left: 10px;"  :disabled = "true" v-for="(opt , index ) in qbErrorView.optionValueArr" :label="String.fromCharCode(65 + index)" :key="opt">{{opt}}</el-checkbox>
                  </el-checkbox-group>
                </div>
                <div style ="margin-top: 10px;"  >
                  <el-tag type="warning">我的答案</el-tag>
                  <span style ="margin-left: 10px;">{{qbErrorView.learnAnswer }}</span>
                  <el-button  size="mini"  :type="qbErrorView.resultOk ? 'success':'danger'"
                  :icon="qbErrorView.resultOk ? 'el-icon-check': 'el-icon-close'" circle></el-button>
                </div>
                <div style ="margin-top: 10px;">
                  <el-tag type="warning">操作</el-tag>
                  <!-- <el-button  type="primary"    size = "small" @click = "seeAnswer()" icon="el-icon-search">查看答案</el-button> -->
                  <el-button  type="primary"   size = "small" icon="el-icon-arrow-left"  @click = "learnNextQb2(false)" >上一题</el-button>
                  <el-button  type="primary"   style="el-icon--right"  size = "small"  @click = "learnNextQb2(true)" icon="">下一题 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
                </div >
                <div style ="margin-top: 10px;" >
                  <el-tag type="warning">答案</el-tag>
                  <span style ="margin-left: 10px;" > {{qbErrorView.answer }}</span>
                </div >
                <div style ="margin-top: 10px;"  >
                  <el-tag type="warning"  >解析</el-tag>
                  <span style ="margin-left: 10px;"> {{qbErrorView.analysis }}</span>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 打开试题预览界面 -->
    <el-dialog :visible.sync="dialogVisual.viewPaperVisual" fullscreen  v-on:close ="clearPaperViewForm" >
      <el-col :span="7" style="">
        <el-card style="height:calc(25vh - 10px);margin-top: 10px;text-align: left; overflow:auto;">
          <div  class="clearfix">
            <el-tag type ="mini" >
              {{ viewThemeOneDetail.theme }}
            </el-tag>
            <!-- <el-tag type ="mini">
              {{ viewThemeOneDetail.moduleName }}
            </el-tag> -->
          </div>
          <div  class="clearfix">
            <el-tag type ="info" size = "mini" v-if="viewThemeOneDetail.usrState == 1" >
              未作答
            </el-tag>
            <el-tag type ="success" size = "mini" v-else-if="viewThemeOneDetail.usrState == 2" >
              考试中
            </el-tag>
            <el-tag type ="danger" size = "mini" v-else>
              已交卷
            </el-tag>
            <el-tag type ='primary' size="mini" v-if="viewThemeOneDetail.usrState == 2 && !viewThemeOneDetail.selfExamOver" style="cursor: pointer;" @click = savePaper(viewThemeOneDetail.id)>暂存</el-tag>
            <el-tag type ='warning' size="mini" v-if="viewThemeOneDetail.usrState == 2" style="cursor: pointer;" @click = sendPaper(viewThemeOneDetail.id)>交卷</el-tag>
            <el-tag :type ="viewThemeOneDetail.result == 0 ? 'danger': 'success'" size="mini" v-if="viewThemeOneDetail.usrState == 3">
              {{ viewThemeOneDetail.result == 0 ? '不合格': '合格' }}
            </el-tag>
            <el-tag type ="mini" v-if="viewThemeOneDetail.usrState == 3">
              {{ viewThemeOneDetail.score }} 分
            </el-tag>
          </div>
            <div>
              <span style="margin-top : 5px">总分数: {{ viewThemeOneDetail.totalScore }}分; </span>
              <span style="margin-top : 5px">及格分数:{{ viewThemeOneDetail.passScore }}分; </span>
              <span style="margin-top : 5px">考试时长:{{ viewThemeOneDetail.duration }}分钟; </span>
              <div style="margin-top : 5px">注意:少选，多选，错选不得分 </div>
            </div>
            <div style="width: 100%; " v-if="viewThemeOneDetail.usrState == 3">
              <span>
                答题时间: {{ viewThemeOneDetail.beginExamTime }}到{{ viewThemeOneDetail.commitExamTime }}
              </span>
            </div>
            <div style="width: 100%;" v-if="viewThemeOneDetail.usrState == 2 && !viewThemeOneDetail.selfExamOver">
              <el-tag type ="danger" size="mini" >
               考试时间还剩:
              </el-tag>
              <span>
               {{ timer.minutes }}分{{ timer.seconds }}秒
              </span>
            </div>
            <div style="width: 100%;" v-if="viewThemeOneDetail.usrState == 2 && viewThemeOneDetail.selfExamOver">
              <el-tag type ="danger" size="mini" >
               考试结束，请交卷
              </el-tag>
            </div>
        </el-card>
        <el-card style="height:calc(60vh - 10px); text-align: left; margin-top:calc(1vh);overflow:auto;">
          <div v-for = "(item,index) in viewThemeOneDetail.qtList" :key="index" style="margin-top:10px">
            <el-tag type ="mini"> {{item.answerCheckType}}</el-tag><span style="padding-left:10px;">{{'共' +item.qbList.length+ '题,' }}</span>
            <span >{{'每题' +item.oneScore+ '分,'}}</span>
            <span>{{'共' + (item.qbList.length * item.oneScore) + '分' }}</span>
            <el-checkbox-group v-model="viewPaperCheckList"  @change="selectedOne">
              <el-checkbox  v-for = "(ite,index) in item.qbList" :key="ite.id"  
              :label="ite.examQuestionId.toString()" :style = "answerCheckList['$$' +ite.examQuestionId ].length  == 0 ? 'color :rgb(208, 82, 82)': 'color:rgb(12, 239, 12)' "> 
                {{index + 1}}  
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-card>
      </el-col>
      <el-col :span="17">
        <el-card style="height:calc(86vh - 19px); text-align: left; margin-top:10px;margin-left:20px; overflow:auto;">
          <div slot="header" class="clearfix">
          <el-tag type="warning">{{ qbView.uniqNo }}</el-tag>
          <el-tag>{{ qbView.moduleName }}</el-tag>
          <el-tag type="success">{{  qbView.answerCheckType }}</el-tag>
          <el-button  type="danger"  v-if ="viewThemeOneDetail.usrState == 3 &&  qbView.learnAnswer != null&& qbView.learnAnswer != '' &&  qbView.learnAnswer != qbView.answer"   style="el-icon--right" @click="recordErrorQb()" size = "small" icon="">加入错题集 <i class="el-icon-arrow-right el-icon--right"></i></el-button>         
        </div>
        
        <div style ="margin-top: 10px;">
          <el-tag type="warning">问题</el-tag>
          <span style ="margin-left: 10px;">{{qbView.question }}</span>
        </div>
        <div style ="margin-top: 10px;" v-if = "qbView.imageUrlList.length > 0"> 
          <el-tag type="warning" style="padding-top: 0px">图片</el-tag>
          <el-badge  v-for="(item,index) in qbView.imageUrlList" :key = "index"  :value="index + 1" class="item">
            <el-image   
              style="width: 100px; height: 100px;margin-left: 10px; "
              :src="item.url"
              :fit="'fit'">
            </el-image>
          </el-badge>
          </div>
          <div style ="margin-top: 10px;">
            <el-checkbox-group v-model="answerCheckList['$$' + qbView.examQuestionId]" >
              <el-tag type="warning">选项</el-tag>
              <el-checkbox style ="margin-left: 10px;" :disabled = " !(viewThemeOneDetail.usrState == 2 && !viewThemeOneDetail.selfExamOver)"  v-for="(item,index ) in qbView.optionValueArr" :label="item.label" :key="index">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div style ="margin-top: 10px;" v-if ="viewThemeOneDetail.usrState == 3" >
            <el-tag type="warning">我的答案</el-tag>
            <span v-if ="qbView.learnAnswer != null && qbView.learnAnswer != ''" style ="margin-left: 10px;">{{ qbView.learnAnswer }}</span>
            <span v-else>未作答</span>
            <el-button   style ="margin-left: 50px;" size="mini"  :type="qbView.learnAnswer == qbView.answer ? 'success':'danger'"
              :icon="qbView.learnAnswer == qbView.answer  ? 'el-icon-check': 'el-icon-close'" circle></el-button>
          </div>
          <div style ="margin-top: 10px;" v-if="viewThemeOneDetail.usrState == 3">
            <el-tag type="warning">答案</el-tag>
            <span style ="margin-left: 10px;"> {{qbView.answer }}</span>
          </div >
          <div style ="margin-top: 10px;" v-if="viewThemeOneDetail.usrState == 3">
            <el-tag type="warning">解析</el-tag>
            <span style ="margin-left: 10px;"> {{qbView.analysis }}</span>
          </div>
        </el-card>
      </el-col>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisual.viewZs" fullscreen v-on:close ="clearZsBox">
     
        <div v-if = "zsBox.zsImage == null  || zsBox.zsImage == ''"   class="zs" ref = "canvasDom">
          <div style="display:block">
            <div style="text-align:left;margin-top:40px">{{zsBox.fullName }}:</div>
            <div style="text-align:left; margin-top:10px;width:800px;text-indent:2em">您在"{{zsBox.theme}}"的考试中表现优秀，成绩合格。</div>
            <div style="text-align:left; margin-top:10px;text-indent:2em">特发此证</div>
            <div style="text-align: left; font-size: 20px;">
              <div style="margin-top:10px; margin-left:550px">天津大学浙江研究院</div>
              <div style="margin-left:570px">{{ zsBox.date }}</div>
            </div>
          </div>
       </div>
       <div  v-else  id = 'zsImage'   style="width:1000px; height: 600px; margin:auto">
        <img :src = "zsBox.zsImage"  style="width:1000px; height: 600px;  margin:auto"/>
       </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisual.editUserInfoDialogVisible" v-on:close ="clearEditUserInfoForm" >
      <div slot="title" class="dialog-footer">
        <span> 用户{{ userInfoForm.usrName }} 信息变更 </span>
      </div>
      <el-form  label-width="20%"  :model="userInfoForm">
        <el-form-item label="更新头像:"  style="text-align:left" label-width="20%"  >
          <el-switch
            v-model="userInfoForm.updateImage"
            active-text="是"
            inactive-text="否"  @change ="funcUpdateImageChange">
          </el-switch>
        </el-form-item>
        <el-form-item  style="text-align:left" label-width="20%"  label="头像:"  >
          <el-upload
          :action="'#'"
          list-type="picture-card"
          :auto-upload="false"
          :ref="userInfoForm.refElUpload"   
          :file-list="userInfoForm.fileList" 
          :limit="userInfoForm.limit">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt  />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-delete"
                @click="handleRemove(file,userInfoForm.refElUpload)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
        </el-form-item>
        <el-form-item  label="姓名:">
          <el-input v-model="userInfoForm.fullName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item  label="性别:">
          <el-select  style="width: 100%" v-model="userInfoForm.gender" placeholder="请选择">
            <el-option
              v-for="item in genderArr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机:">
          <el-input  v-model="userInfoForm.mobilePhone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱:">
          <el-input v-model="userInfoForm.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="团队:"  >
          <el-select  v-model="userInfoForm.deptId" style="width:100%" placeholder="请选择" >
            <el-option
              v-for="item in deptOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureChange">确定变更</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisual.changePassVisible" v-on:close ="clearEditUserPassForm" >
      <div slot="title" class="dialog-footer">
        <span> 修改{{ userInfoForm.usrName }} 密码 </span>
      </div>
      <el-form  label-width="20%"  :model="userInfoForm">
        <el-form-item label="原密码:">
          <el-input  v-model="changePassword.oldPassword" show-password  autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码:">
          <el-input v-model="changePassword.newPassword" show-password  autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureChangePass">确定变更</el-button>
      </div>
    </el-dialog>
  </div>
</template>                        
<script>
// 引入组件
import axios from  '@/api/axiosConfig'
import {getToken} from  '@/api/utils'
import html2canvas from 'html2canvas'
import {stringIsNullOrEmpty,regCheck} from  '@/api/utils'
import {MESSAGE_DURATION,GENDER_ARR,passWordReg, regEmail,regMobilePone} from  '@/api/constant'
import {convertDateFromString} from '@/api/utils'
export default {
  name : 'pc_self',
  data() {
    return {
      tokenObj:{token:''},
      genderArr: GENDER_ARR,
      examList:[],
      pager:{
        totalCount:0,
        pageSize : 5                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
      },
      userInfo :{
        id :'',
        init : false,
        fullName: '',
        usrName: '',
        deptName : '',
        deptId :'',
        gender :'',
        genderShow :'',
        email :'',
        mobilePhone :'',
        imageUrl: ''
      },
      timer:{
        noticeSignPaper: false,
        beginExamTime :'',
        timerId :'',
        minutes :'',
        seconds:'',
        duration :''
      },
      pageRoute : {
        pageState : '0',
        pageDir :'个人信息',
      },
      deptOptions: [],
      userInfoForm: {
        updateImage:false,
        fullName: '',
        usrName: '',
        deptId : '',
        gender :'',
        email :'',
        mobilePhone :'',
        fileList:[],
        id : '',
        refElUpload :"userImagUpload",
        limit : 1,
        imageUrl :''
      },
      dialogVisual:{
        editUserInfoDialogVisible:false,
        changePassVisible :false,
        viewPaperVisual :false,
        viewZs : false
      },
      changePassword :{
        oldPassword:'',
        newPassword :''
      },
      viewThemeOneDetail: {
        id : '',
        theme:'',
        // moduleName :'',
        usrState :'',
        score:'',
        beginExamTime :'',
        commitExamTime :'',
        result:'',
        totalScore:'',
        passScore:'',
        examState :'',
        selfExamOver :'',
        duration :'',
        qtList :[]
      },
      viewPaperCheckList:[],
      answerCheckList:{},
      qbView :{
        examQuestionId :'',
        id:'',
        learnAnswer:'',
        analysis:'',
        answer:'',
        question :'',
        optionValueArr:[],
        moduleName:'',
        uniqNo:'',
        checkedOptList:[],
        answerCheckType :'',
        imageUrlList :[]
      },
      qbErrorView :{
        errorId :'',
        examQuestionId :'',
        id:'',
        learnAnswer:'',
        analysis:'',
        answer:'',
        question :'',
        optionValueArr:[],
        moduleName:'',
        uniqNo:'',
        answerCheckType :'',
        imageUrlList :[]
      },
      zsBox :{
        fullName :'',
        theme :'',
        date :'',
        zsImage:''
      }
    }
  },
  methods : {
    routeFunc(){
      window.parent.postMessage({
        data: "1",
      }, '*');
    },

    timerFunc(){
      if(this.timer.seconds == '' || this.timer.seconds == 0){
        //const startTime = new Date( this.timer.beginExamTime)
        const startTime =  convertDateFromString(this.timer.beginExamTime)
        const endTime = new Date();
        const timeDiff = (startTime.getTime()  + this.timer.duration * 1000 * 60 ) - endTime.getTime()
        if (timeDiff < 0 ){
          this.viewThemeOneDetail.selfExamOver = true
        }else{
          const totalSeconds =  Math.floor(timeDiff / 1000)
          if(!this.timer.noticeSignPaper && totalSeconds < 3 * 60) {
              this.$message({
              showClose: true,
              message: '离考试结束时间不到3分钟，请尽快交卷！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
            this.timer.noticeSignPaper = true
          }
          this.timer.minutes = Math.floor(totalSeconds / 60)
          this.timer.seconds = Math.floor(totalSeconds % 60)
        }
      }else{
        this.timer.seconds = this.timer.seconds  - 1
      }
    },
    
    handleCommitPaper(examId){
      let url = "/bc/exa/exam/examCommitPaper"
      let dat ={
        themeId:examId,student:true
      }
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'success',
            duration: MESSAGE_DURATION
          }) 
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        }) 
      })

    },
    sendPaper(themeId){
      let fieldArr =  Object.keys(this.answerCheckList)
      let answerArr = []
      let count  = 0
      for(let i = 0 ; i< fieldArr.length; i++){
        let examQuestionId =  fieldArr[i].substring(2) ;
        let answerList =  this.answerCheckList[fieldArr[i]]
        if(answerList.length == 0){
          count++ 
        }else{
          let learnAnswer   = answerList.sort().join("")
          answerArr.push({themeId, examQuestionId, answer:learnAnswer})
        }
      }
      let message = "请确认是否交卷？"
      if(count != 0){
        message = "检查到还有" + count  + "个题目未作答,请确认是否交卷？"
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doSendPaper(themeId,answerArr)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doSendPaper(themeId,dat){
      let url = "/bc/exa/exam/examSendPaper/" + themeId
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'success',
            duration: MESSAGE_DURATION
          }) 
          this.dialogVisual.viewPaperVisual = false
          this.clearPaperViewForm()
          //setTimeout(()=>{this.examListLoad(1)},200)
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        }) 
      })
    },

    savePaper(themeId){
      let fieldArr =  Object.keys(this.answerCheckList)
      let answerArr = []
      for(let i = 0 ; i< fieldArr.length; i++){
        let examQuestionId =  fieldArr[i].substring(2) 
        let answerList =  this.answerCheckList[fieldArr[i]]
        if(answerList.length != 0){
          let learnAnswer   = answerList.sort().join("")
          answerArr.push({ examQuestionId, answer:learnAnswer})
        }
      }
      if(answerArr.length == 0 ){
        this.$message({
          showClose: true,
          message: '您还未开始答题',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      this.$confirm('是否要暂存考试答案?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doSavePaper(themeId,answerArr)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消提交！'
        });
      })
    },

    doSavePaper(themeId,dat){
      let url = "/bc/exa/exam/examSavePaper/"  + themeId
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'success',
            duration: MESSAGE_DURATION
          }) 
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },

    clearTimer (){
      if(this.timer.timerId != ''){
        clearInterval(this.timer.timerId)    
        this.timer.beginExamTime = ''
        this.timer.timerId  = ''
        this.timer.minutes = ''
        this.timer.seconds = ''
        this.timer.duration = ''
      }
    },

    clearPaperViewForm(){    
      this.clearTimer()
      this.answerCheckList = {}
      this.viewThemeOneDetail.id = ''
      // this.viewThemeOneDetail.moduleName = ''
      this.viewThemeOneDetail.usrState = ''
      this.viewThemeOneDetail.score = ''
      this.viewThemeOneDetail.beginExamTime = ''
      this.viewThemeOneDetail.commitExamTime = ''
      this.viewThemeOneDetail.examState = ''
      this.viewThemeOneDetail.id = ''
      this.viewThemeOneDetail.selfExamOver = ''
      this.viewThemeOneDetail.theme = ''
      this.viewThemeOneDetail.totalScore = ''
      this.viewThemeOneDetail.passScore = ''
      this.viewThemeOneDetail.duration = ''
      this.viewPaperCheckList.splice(0)
      this.viewThemeOneDetail.qtList.splice(0)
      this.clearViewQbForm()

      setTimeout(()=>{this.examListLoad(1)},200)
    },

    clearViewQbForm(){
      this.qbView.id = ''
      this.qbView.answerCheckType = ''
      this.qbView.examQuestionId = ''
      this.qbView.analysis = ''
      this.qbView.answer = ''
      this.qbView.question = ''
      this.qbView.moduleName = ''
      this.qbView.learnAnswer = ''
      this.qbView.uniqNo= ''
      this.qbView.optionValueArr.splice(0)
      this.qbView.imageUrlList.splice(0)
    },

    seePaper(id) {
      this.handleViewPaper(id,null)
    },


    printZs(item){
      this.dialogVisual.viewZs = true
      this.zsBox.fullName = item.fullName
      this.zsBox.theme = item.examTheme
      let date = new Date();
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      this.zsBox.date = year +'年' + month +'月' + day + '日'
      setTimeout(()=>{ 
      const canvasDom = this.$refs.canvasDom
      html2canvas(canvasDom, {
        dpi: 300, // 解决生产图片模糊
        useCORS: true,
        allowTaint: false,
        logging: false,
        scale: 2,
        windowHeight: 1000
      }).then((canvas) => {
        this.zsBox.zsImage = canvas.toDataURL('image/png')
        setTimeout(()=>{
          const content = document.getElementById('zsImage').innerHTML
          let newWindow = window.open('', '打印窗口');
          newWindow.document.write('<html><head><title>安全考试证书</title></head><body>' + content + '</body></html>');
          newWindow.document.close();
          newWindow.print();
          newWindow.close();
        },200)
      }).catch((e) => {
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })},300)
    },
    clearZsBox(){
      this.zsBox.fullName = ''
      this.zsBox.theme = ''
      this.zsBox.date = ''
      this.zsBox.zsImage = ''
    },
    showZs(item){
      this.dialogVisual.viewZs = true
      this.zsBox.fullName = item.fullName
      this.zsBox.theme = item.examTheme
      let date = new Date();
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      this.zsBox.date = year +'年' + month +'月' + day + '日'
      setTimeout(()=>{ 
      const canvasDom = this.$refs.canvasDom
      html2canvas(canvasDom, {
          dpi: 300, // 解决生产图片模糊
          useCORS: true,
          allowTaint: false,
          logging: false,
          scale: 2,
          windowHeight: 1400
        }).then((canvas) => {
          this.zsBox.zsImage = canvas.toDataURL('image/png')      
          let a = document.createElement('a');
          document.body.appendChild(a)
          a.setAttribute("download", `考试证书_${this.zsBox.theme}.png`);
          a.setAttribute("href", this.zsBox.zsImage)
          a.click()
          document.body.removeChild(a) 
        })
        .catch((e) => {
          this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        })
      },1000)
    
    },
    removeErrorQb(){
      if(this.qbErrorView.errorId == ''){
          return
      }
      let url = "/bc/exa/error/deleteError"
      let dat0 = { id :this.qbErrorView.errorId }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '移除错题成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          setTimeout(()=>{this.errorNextOneLoad(this.qbErrorView.errorId,true)},200)
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })
    },

    recordErrorQb(){
       if(this.viewThemeOneDetail.usrState != 3){
        this.$message({
          showClose: true,
          message: '未交卷，不能加入错题集',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      if( this.qbView.resultOk){
        this.$message({
          showClose: true,
          message: '您的答案是正确的，不能加入错题集',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      
      
      let url = "/bc/exa/error/addError"
      let dat0 = { qbId:this.qbView.id,errorAnswer:this.qbView.learnAnswer }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '加入错题集成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })

    }, 

    handleCommandExam(obj){
      console.log(obj )
      let{ examId , examCount , examMaxCount} = obj
      if(examCount == 0){
        this.handleReExamPaper(examId) 
      }else{
        if(examCount == examMaxCount){
          this.handleViewPaper(examId , null)
        }else{
          this.handleViewPaper(examId , examCount)
        }
      }
    },

    handleReExamPaper(id){
      let dat = {
        themeId : id 
      }
      let url = "/bc/exa/themeUser/reExam"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.handleViewPaper(id, null)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    handleViewPaper( id, examCount){
      this.dialogVisual.viewPaperVisual = true
      let dat = {
        id ,
        examCount,
        student:true
      }
      let url = "/bc/exa/exam/getExamThemeOneDetail"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          let dat = response.data.data
          this.viewThemeOneDetail.usrState = dat.usrState
          this.viewThemeOneDetail.score = dat.score
          this.viewThemeOneDetail.beginExamTime = dat.beginExamTime
          this.viewThemeOneDetail.commitExamTime = dat.commitExamTime
          this.viewThemeOneDetail.examState = dat.examState
          this.viewThemeOneDetail.result = dat.result
          this.viewThemeOneDetail.id = dat.id
          this.viewThemeOneDetail.theme = dat.theme
          this.viewThemeOneDetail.totalScore = dat.totalScore
          this.viewThemeOneDetail.passScore = dat.passScore
          this.viewThemeOneDetail.duration = dat.duration
          this.viewThemeOneDetail.selfExamOver  = dat.selfExamOver
          this.viewThemeOneDetail.qtList.splice(0)
          this.viewThemeOneDetail.qtList = [... dat.qtList]
          this.viewPaperCheckList = []
    
          // 正在考试并且未超时
          if(this.viewThemeOneDetail.usrState == 2 &&  !this.viewThemeOneDetail.selfExamOver) {
            this.timer.beginExamTime = response.data.data.beginExamTime
            this.timer.duration = dat.duration
            this.timer.timerId = setInterval(this.timerFunc,1000)
          }
          
          let first = this.viewThemeOneDetail.qtList[0].qbList[0].examQuestionId
          for(let  i = 0 ;i< this.viewThemeOneDetail.qtList.length ; i++){
            let qt =this.viewThemeOneDetail.qtList[i]
            for(let  j = 0 ;j< qt.qbList.length ; j++){
              let qb = qt.qbList[j]
              let arr = []
              // 保证动态绑定
              if(dat.usrState >= 2 && qb.learnAnswer != null && qb.learnAnswer != ''){
                arr = [... qb.learnAnswer]
              }
              this.$set(this.answerCheckList,'$$' + qb.examQuestionId,arr)
            }
          }
          setTimeout(()=> this.handleViewQb(first.toString()),300)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    
    handleViewQb(last){
      this.viewPaperCheckList.push(last)
      let row = '';
      let qtList = this.viewThemeOneDetail.qtList
      for(let i = 0; i< qtList.length ; i++){
        let qbList = qtList[i].qbList
        for(let j = 0; j < qbList.length; j++  ){
          if( qbList[j].examQuestionId == last ){
            row = qbList[j]
            break
          }
        }
      }
      this.qbView.id = row.id
      this.qbView.examQuestionId = row.examQuestionId
      this.qbView.analysis = row.analysis
      this.qbView.answer = row.answer
      this.qbView.question = row.question 
      this.qbView.moduleName=row.moduleName
      this.qbView.learnAnswer=row.learnAnswer
      this.qbView.uniqNo=row.uniqNo
      this.qbView.answerCheckType =row.answerCheckType
      for(let i = 0; i< 5; i++){
        let v =  row['option' + (i + 1)]
        if(v != null &&  v != '') {
          let ch = String.fromCharCode(i + 1 + 64)
          this.qbView.optionValueArr.push(  {  label :ch , name: ch + "."+ v + ";"}  )
        }
      }
      for(let i = 0; i< row.countImage; i++){
        this.qbView.imageUrlList.push({name: row.id , url : row['fileUrl'+ (i+1)]})
      }
    },
    selectedOne( val){
      this.clearViewQbForm()
      let last= this.viewPaperCheckList.pop()
      this.viewPaperCheckList = []
      setTimeout(()=> this.handleViewQb(last),200)
    },
    
    handleRemove(file,refElUpload) {
      let fileList = this.$refs[refElUpload].uploadFiles
      let index = fileList.indexOf(file)
      this.$refs[refElUpload].uploadFiles.splice(index,1)
    },
    ensureChange(){
      this.$confirm('即将更新用户['+this.userInfoForm.usrName+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doChangeUserInfo()
      }).catch((e) => {
        this.$message({
          type: 'info',
          message: '取消更新！ '+ e
        });
      })
    },
    doChangeUserInfo(){
      try{
        if(this.userInfoForm.updateImage){
          let fileObj = this.$refs[this.userInfoForm.refElUpload]
          if(fileObj == null){
              throw '更新头像请选择头像1'
          }else{
            let fileList = fileObj.uploadFiles
            if(fileList == null || fileList.length == 0){
              throw '更新头像请选择头像2'
            }
          }
        }
        if (this.userInfoForm.email != null && this.userInfoForm.email != '') {
          regCheck(regEmail, this.userInfoForm.email,'邮箱格式不正确!');
        }
        if (this.userInfoForm.mobilePhone != null && this.userInfoForm.mobilePhone != '') {
          regCheck(regMobilePone, this.userInfoForm.mobilePhone,'手机号码格式不正确!')
        }
      }catch(e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      let url = "/bc/exa/usr/usrEdit"
      let param =  new FormData()
      param.append('id',this.userInfoForm.id)
      param.append('fullName',this.userInfoForm.fullName)
      param.append('usrName', this.userInfoForm.usrName)
      param.append('deptId', this.userInfoForm.deptId)
      param.append('gentle', this.userInfoForm.gender)
      param.append('email', this.userInfoForm.email)
      param.append('mobilePhone', this.userInfoForm.mobilePhone)
      if(this.userInfoForm.updateImage){
         let file = this.$refs[this.userInfoForm.refElUpload].uploadFiles[0]
         param.append('file',file.raw)
      }
    
      axios.post(url, param,{
        headers: {
          'Content-Type': 'multipart/form-data',
          // 'token': this.tokenObj.TOKEN
        }}).then((response) => {
          if (response.data.code === 0){
            this.dialogVisual.editUserInfoDialogVisible= false;
            this.clearEditUserInfoForm();
            this.$message({
              showClose: true,
              message: '更新成功',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            setTimeout(()=>{this.getUserInfo()},200)
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },

    changePass(){
      this.dialogVisual.changePassVisible =true
    },
    async handleEdit(){
      if(this.deptOptions.length == 0){
        await this.deptListLoad()
      }
      this.dialogVisual.editUserInfoDialogVisible = true
      this.userInfoForm.fullName = this.userInfo.fullName
      this.userInfoForm.updateImage = false
      this.userInfoForm.usrName = this.userInfo.usrName
      this.userInfoForm.gender = this.userInfo.gender
      this.userInfoForm.email = this.userInfo.email
      this.userInfoForm.mobilePhone = this.userInfo.mobilePhone
      this.userInfoForm.deptId = this.userInfo.deptId
      this.userInfoForm.imageUrl = this.userInfo.imageUrl
      if(this.userInfo.imageUrl!= null && this.userInfo.imageUrl != ''  ){
        this.userInfoForm.fileList.push({name:this.userInfo.usrName, url:this.userInfo.imageUrl})
      }
      this.userInfoForm.id = this.userInfo.id
    },
    handleCurrentChange(val){
     // this.regListLoad(val)
     this.examListLoad(val)
    },
    funcUpdateImageChange(){
      let rawImageUrl = this.userInfoForm.imageUrl
      let rawHasFile = false
      if(rawImageUrl != null && rawImageUrl != ''){
        rawHasFile = true
      }
      if(this.userInfoForm.updateImage){
        if(this.$refs[this.userInfoForm.refElUpload] != null){
          this.$refs[this.userInfoForm.refElUpload].clearFiles()
        }
        if(rawHasFile){
          this.userInfoForm.fileList.splice(0)
        }
      }else{
        if(rawHasFile){
          this.userInfoForm.fileList.push({name:this.userInfoForm.usrName, url:rawImageUrl})
        }
      }
    },
    handleSelect(index){
      this.pageRoute.pageState = index
      if(index == '0'){
        if(!this.userInfo.init){
            this.getUserInfo()
        }
        this.pageRoute.pageDir = "个人信息" 
      }else if(index == '1') {
        this.pageRoute.pageDir = "安全考试" 
        if(this.examList.length == 0){

          this.examListLoad(1)
        }
        
      }else if( index == '2'){
        this.pageRoute.pageDir = "错题集" 
        if(this.qbErrorView.errorId == '' ){
          this.errorNextOneLoad(0,true)
        }
      }
    },
    // 加载团队清单
    async  deptListLoad(){
      let url = "/bc/exa/dept/getDeptTree"
      let dat = {}
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.length !== 0){
            response.data.data.forEach(t=>{
              this.deptOptions.push({value: t.id,label: t.deptName })
            })
          }else{
            this.$message({
              showClose: true,
              message: '团队列表未查询到数据！',
              type: 'warning',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },

    examListLoad(pageNo){
      let url = "/bc/exa/exam/selectUserExamPage"
      let dat = {
        student:true,
        pageNo,
        pageSize : 5,
        }
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.data.length !== 0){
            this.examList.splice(0)
            response.data.data.data.forEach(t=>{
              this.examList.push(t)
            })
            this.pager.totalCount = response.data.data.totalDataCount
          }else{
            this.$message({
              showClose: true,
              message: '未查询到考试信息！',
              type: 'warning',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    learnNextQb2(asc){

      this.errorNextOneLoad(this.qbErrorView.errorId ,asc) 

    },
    errorNextOneLoad(errorId,asc){
      let url = "/bc/exa/error/nextQb"
      let dat0 = { errorId, asc }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          this.qbErrorView.errorId = dat.errorId
          this.qbErrorView.analysis = dat.analysis
          this.qbErrorView.id = dat.id
          this.qbErrorView.answer = dat.answer
          this.qbErrorView.question = dat.question 
          this.qbErrorView.moduleName = dat.moduleName
          this.qbErrorView.uniqNo = dat.uniqNo
          this.qbErrorView.answerCheckType =dat.answerCheckType
          this.qbErrorView.learnAnswer = dat.errorAnswer
          this.qbErrorView.resultOk =  dat.resultOk
         //this.qbErrorView.learnTime = dat.learnTime
          this.qbErrorView.imageUrlList.splice(0)
          this.qbErrorView.optionValueArr.splice(0)
          // this.qbErrorView.checkedOptList.splice(0)
          for(let i = 0; i< 5; i++){
            let v =  dat['option' + (i + 1)]
            if(v != null &&  v != '') {
              let ch = String.fromCharCode(i + 1 + 64)
              this.qbErrorView.optionValueArr.push(ch + "."+ v + ";")
            }
          }
          for(let i = 0; i< dat.countImage; i++){
            this.qbErrorView.imageUrlList.push({name: dat.id , url : dat['fileUrl'+ (i+1)]})
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })

    },
    getUserInfo(){
      let url = "/bc/exa/usr/getUsrInfo"
      let dat0 = {
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          if(dat!= null && dat != ''){
            this.userInfo.fullName = dat.fullName
            this.userInfo.usrName = dat.usrName  
            this.userInfo.gender = dat.gentle
            if (dat.gentle == '0') {
              this.userInfo.genderShow = '女'
            } else if (dat.gentle == '1') {
              this.userInfo.genderShow = '男'
            }
            this.userInfo.id = dat.id
            this.userInfo.mobilePhone = dat.mobilePhone
            this.userInfo.email = dat.email
            this.userInfo.deptId = dat.deptId
            this.userInfo.deptName = dat.deptName
            this.userInfo.imageUrl = dat.headImag
            this.userInfo.init = true
          } else {
            this.$message({
              showClose: true,
              message: '未查询到规章制度信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        });
    },
    clearEditUserInfoForm(){
      this.userInfoForm.fileList.splice(0)
      if(this.$refs[this.userInfoForm.refElUpload] !=null ){
        this.$refs[this.userInfoForm.refElUpload].clearFiles()
      }
      this.userInfoForm.fullName = ''
      this.userInfoForm.usrName =''
      this.userInfoForm.gentle = ''
      this.userInfoForm.updateImage = false
      this.userInfoForm.email = ''
      this.userInfoForm.imageUrl = ''
      this.userInfoForm.mobilePhone = ''
      this.userInfoForm.deptId = ''
      this.userInfoForm.id = ''
    },
    clearEditUserPassForm(){
      this.changePassword.oldPassword = ''
      this.changePassword.n = ''
    },
    ensureChangePass(){
      try{ 
        stringIsNullOrEmpty(this.changePassword.oldPassword,'请输入旧密码!');
        stringIsNullOrEmpty(this.changePassword.newPassword,'请输入新密码!');
        regCheck(passWordReg, this.changePassword.newPassword,'新密码格式不正确，格式为6到16位大小写字母,数字,@,$的组合!');
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      let dat = {
        oldPass:this.changePassword.oldPassword,
        newPass:this.changePassword.newPassword
      }
      let s = JSON.stringify(dat);
      let url = "/bc/exa/usr/changePass"
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '密码修改成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })

    },
    restPass(){
      this.$confirm('您确定要重置密码么?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doRestPass();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已经取消重置用户密码!'
          });
        })
    },
    doRestPass(){
      let url = "/bc/exa/usr/resetPass"
      let data = {id: this.userInfo.id}
      let s = JSON.stringify(data)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '重置密码成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    }
    },
    beforeRouteLeave(to, from, next){
   
      this.clearTimer()
      next();
    },
    beforeDestroy(){
 
     this.clearTimer()
   
    },
    created(){

      let active =  this.$route.params.active
      
      // setTimeout(()=>{getToken(this.tokenObj)},200)

      setTimeout(()=>{ this.handleSelect(active) },200)
     
    },
    
    components: {
    }
  }
</script>

<style lang="less" scoped>
.zs {
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  font-weight: 700;
  height: 580px; 
  width:1000px;
  background-repeat: no-repeat;
  background-size: 100% 100%; 
  background-image: url('../../assets/image/zs.png');
}
.el-main-1 {
  width: 100%;
  margin-top:0px;
  padding: auto;
  color: #333;
  text-align: center;
  height: 99%;
  overflow:auto;
}
.el-menu-item.is-active {
  background-color:  rgb(124, 203, 199);
}
.el-row {
  padding: auto;
  margin: auto;
  height: 300px;
  width: 1400px;
  font-size: large;
  text-align: center;
}

.el-divider--horizontal{
  background-color: #2577d5;
  height: 2px;
  margin: 1px 0 10px 0;
  width: 100%
}


.tzgg-ul{
    width:90%;
    margin: auto;
    &:first-child {
      margin-top: 20px;
    }
    .tzgg-ul-li{
      height: 50px;
      line-height: 18px;
      font-size: 18px;
      border-bottom: 1px solid #DCDFE6;
      display: flex ;
      align-items: center;
      i{
        width:5px;
        height:5px;
        display:inline-block;
        background-color:rgb(124, 203, 199);
        margin-bottom: 5px;
        margin-left: 5px;
        transform:rotate(45deg);
      }
      a{
        width:75%;
        overflow: hidden;
        padding-left: 1em;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        text-align: left;
        font-size: 1em;
      }
      span{
        width:20%;
        display:inline-block;
        font-size: 0.8em;
        color: #6F6F6F;
        white-space: nowrap;
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>
  


// WEBPACK FOOTER //
// src/pc_pages/pc_component/pc_self.vue